import { useRef, useState } from 'react';

import KeyboardIcon from '@/assets/icon/keyboard.svg';
import AudioIcon from '@/assets/icon/audio.svg';
import EmojiIcon from '@/assets/icon/emoji.svg';
import PlusIcon from '@/assets/icon/plus.svg';

import style from './chat.input.module.less';
import AudioController from '@/pages/MainPage/MainArea/Room/AudioController';

enum ChatInputType {
  TEXT = 'TEXT',
  VOICE = 'VOICE',
}

function ChatInput({ onConfirm }: { onConfirm: (message: string) => void }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [chatType, setChatType] = useState<ChatInputType>(ChatInputType.TEXT);
  const [message, setMessage] = useState<string>(''); // 新增：用于保存输入的消息

  const handleSwitchInputMode = () => {
    const newType = chatType === ChatInputType.VOICE ? ChatInputType.TEXT : ChatInputType.VOICE;
    setChatType(newType);
    if (newType === ChatInputType.TEXT) {
      // 使用setTimeout确保DOM更新完成
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          // 强制触发虚拟键盘
          inputRef.current.inputMode = 'text';
          // 安卓微信浏览器兼容方案
          const event = new Event('touchstart', { bubbles: true });
          inputRef.current.dispatchEvent(event);
        }
      }, 50);
    }
  };

  const handleSendMessage = (event: any) => {
    if (event.key === 'Enter') {
      // 检测是否是回车键
      event.preventDefault();
      onConfirm(message);
      setMessage('');
    }
  };

  return (
    <div className={`${style.chatInputWrapper}`}>
      <div className={style.chatInputContainer}>
        <div className={style.chatInputIcon} onClick={handleSwitchInputMode}>
          <img src={chatType == ChatInputType.VOICE ? KeyboardIcon : AudioIcon} alt="" />
        </div>
        <div className={style.chatInputBox}>
          {chatType === ChatInputType.TEXT && (
            <input
              ref={inputRef}
              value={message} // 绑定值
              onChange={(e) => setMessage(e.target.value)} // 更新状态
              onKeyDown={handleSendMessage} // 添加键盘事件处理器
              className={style.chatInnerInputBox}
              inputMode="text"
              enterKeyHint="send"
              autoCapitalize="sentences"
            />
          )}
          {chatType === ChatInputType.VOICE && <AudioController />}
        </div>
        <div className={style.chatInputIcon}>
          <img src={EmojiIcon} alt="" />
        </div>
        <div className={style.chatInputIcon}>
          <img src={PlusIcon} alt="" />
        </div>
      </div>
    </div>
  );
}

export default ChatInput;
